import React from 'react';
import { Box } from '@material-ui/core';
import { useStylesMentorCard } from './styles';
import { ReactComponent as MentorSVG } from './assets/mentor-placeholder.svg';
import { MentorHeaderProps } from './interface';

const MentorHeader = ({ profileImage }: MentorHeaderProps) => {
  const classes = useStylesMentorCard({});
  return (
    <Box className={classes.header}>
      <Box className={classes.banner} />
      {profileImage ? (
        <img alt="Mentor" className={classes.mentorImage} src={profileImage} />
      ) : (
        <MentorSVG className={classes.mentorImage} />
      )}
    </Box>
  );
};

export default MentorHeader;
